import { EditCtrl } from "../../Editor/index"

export default class PolozkaCennikaEditCtrl extends EditCtrl {

  static $inject = ["item", "typyPoloziek", "saveHandler", "$timeout", "$rootScope"];

  constructor(item, typyPoloziek, saveHandler, $timeout, $rootScope){
    super(item, saveHandler);

    $timeout(() => this.form.$setPristine());

    this.typyPoloziek = typyPoloziek.result;

    this.$rootScope = $rootScope;
  }

  submit() {
    this.form.$setSubmitted();

    if (this.form.$valid) {
      let dto = {};
      if (this.item.id === 0)
        dto.cennik = this.item.cennik;

      for (let key of ['jednotkovaCena', 'mena', 'typPolozky'])
        if (this.form[key].$dirty)
          dto[key] = this.item[key];

      for (let key of ['platnostOd', 'platnostDo'])
        if (this.form[key].$dirty)
          dto[key] = `${this.item[key].getFullYear()}-${this.item[key].getMonth() + 1}-${this.item[key].getDate()}`;

      this.saveHandler(this.item.id, dto).then(() => {
        this.$rootScope.back();
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/Cennik/PolozkaCennika/PolozkaCennikaEditCtrl.js